/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.0.0
 */
import { Middleware } from 'redux';

/**
 * The middleware logs all actions and state in dev mode
 */
const loggerMiddleware: Middleware = ({ getState }) => (next) => (action) => {
  const result = next(action);

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
      console.info('[Dispatching]', action, getState());
  }

  return result;
};

export default loggerMiddleware;
